import {
  IconArrowLeft,
  IconComments,
  IconLikes,
  IconSendMessage,
  IconShares,
} from '@app/icons';
import { useNavigate } from 'react-router-dom';
import styles from './NewsCardPage.module.scss';
import image from '../news.jpg';
import { memo } from 'react';
import { Card, CardContent, CardFooter } from 'components/ui/card';
import { Input } from 'components/ui/input';
import { Button } from 'components/ui/button';

const NewsCardPage = memo(() => {
  const navigate = useNavigate();

  return (
    <Card className="max-w-2xl mx-auto my-8">
      <CardContent>
        <div className="flex items-center gap-4 mb-4">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <IconArrowLeft />
          </Button>
          <span className="text-lg font-semibold">Вам подарок!</span>
          <p className="ml-auto text-xs text-muted-foreground">12.01.2022</p>
        </div>
        <div className="flex flex-col md:flex-row gap-6">
          <div className="flex-shrink-0 w-full md:w-64 h-48 overflow-hidden rounded-lg bg-gray-100 flex items-center justify-center">
            <img className="object-cover h-full w-full" src={image} alt="" />
          </div>
          <div className="flex-1">
            <span className="block text-sm font-medium mb-1">Описание</span>
            <p className="text-gray-700 text-sm mb-4">
              В этом декабре Дед Мороз придет не только к детям, но и к
              покупателям апартаментов в Донском квартале! Все мы помним тот
              трепет и приятное волнение ребенка, когда под новогодней елкой
              появлялись красивые коробки с заветными подарками. Предлагаем
              ненадолго вернуться в детство и впустить в свою жизнь чуточку
              волшебства. Мы с Дедом Морозом подготовили подарки для любимых
              клиентов. Все, что нужно — выбрать свой под елочкой. Мы хотим,
              чтобы в этот Новый год для вас было на одно чудо больше. С
              теплотой и заботой, ваш Донской квартал.
            </p>
            <div className="flex gap-4 mb-4">
              <span className="flex items-center gap-1 text-xs text-muted-foreground">
                <IconComments /> 20
              </span>
              <span className="flex items-center gap-1 text-xs text-muted-foreground">
                <IconShares /> 20
              </span>
              <span className="flex items-center gap-1 text-xs text-muted-foreground">
                <IconLikes /> 100
              </span>
            </div>
            <div className="mt-4">
              <label className="block text-xs font-medium mb-1">
                Комментарий
              </label>
              <div className="flex gap-2 items-center">
                <Input
                  className="flex-1"
                  type="text"
                  placeholder="Введите текст"
                />
                <Button variant="ghost" size="icon">
                  <IconSendMessage />
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8">
          <div className="flex items-start gap-4 p-4 border rounded-lg mb-2">
            <img
              className="w-10 h-10 rounded-full object-cover"
              src={image}
              alt=""
            />
            <div className="flex-1">
              <span className="block text-xs font-medium">Комментарий</span>
              <p className="text-sm">Вау, классно!!!</p>
              <ul className="text-xs text-muted-foreground mt-1">
                <li className="font-semibold">Автор</li>
                <li>Каримов Алишер Махмутович</li>
              </ul>
            </div>
            <div className="flex flex-col gap-2">
              <Button variant="ghost" size="icon">
                <IconComments />
              </Button>
              <Button variant="ghost" size="icon">
                <IconLikes />
              </Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
});

export default NewsCardPage;
